import { render, staticRenderFns } from "./chat-form.vue?vue&type=template&id=e704f742"
import script from "./chat-form.vue?vue&type=script&lang=ts"
export * from "./chat-form.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports